/**
 * Punto de entrada del frontend.
 *
 * Desde aquí se:
 * - monta React sobre `#root`,
 * - cargan estilos globales,
 * - registra el service worker para capacidades PWA,
 * - y se habilitan métricas opcionales de rendimiento.
 */
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import "./index.css";
import "antd/es/style/reset.css";
import reportWebVitals from "./reportWebVitals";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Registra el SW para habilitar cache, instalación y soporte PWA.
serviceWorkerRegistration.register();
reportWebVitals();
